import { IFetchedImageData } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//어드민 - 이미지 수정 페이지: 기존에 저장된 이미지 리스트 데이터 불러오기
async function getAdminImageData(
  imageId?: number,
  sequenceId?: number | null
): Promise<AxiosResponse<FetchResult<IFetchedImageData>>> {
  const response = await instance.get(
    sequenceId ? `/admin/images/${imageId}?sequenceId=${sequenceId}` : `/admin/images/${imageId}`
  );
  return response;
}

const useFetchAdminImageData = (imageId?: number, sequenceId?: number | null) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', sequenceId ? `/admin/images/${imageId}?sequenceId=${sequenceId}` : `/admin/images/${imageId}`],
    queryFn: () => getAdminImageData(imageId, sequenceId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(imageId)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchAdminImageData;
